// extracted by mini-css-extract-plugin
export default {"containermiddle":"ContainerMiddle_containermiddle__3-8GT","loader":"ContainerMiddle_loader__po6OL","rotation":"ContainerMiddle_rotation__HRgU3"};